import React from "react";
import Avatar from "@mui/material/Avatar";
import Box from "@mui/material/Box";
import Chip from "@mui/material/Chip";
import Typography from "@mui/material/Typography";

export function PublishedByBadge({ user }) {
  if (!user) return null;

  const displayName =
    user.firstName && user.lastName
      ? `${user.firstName} ${user.lastName}`
      : user.username || "Admin";

  return (
    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
      <Avatar src={user.picture} alt={user.firstName} sx={{ width: 28, height: 28 }} />
      <Typography variant="body2">{displayName}</Typography>
      <Chip label="Admin" color="primary" variant="outlined" size="small" />
    </Box>
  );
}
